import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import type { Plugin } from '../plugin'

/**
 * Dispose all dynamic Entity Collections when after Page editing is finished/canceled.
 */
export const triggerEcDispose = store.effects.create(
  (
    feature: Plugin['feature'],
    plugin: Plugin,
    dynamicEcsFeature: dynamicEcs.Feature,
  ) =>
    rxjs
      .merge(
        plugin.collection.plugins.editingPlugin.feature.actions.submit.success.observe(),
        plugin.collection.plugins.editingPlugin.feature.actions.discard.success.observe(),
      )
      .pipe(
        rxjs.map(action =>
          dynamicEcsFeature.actions.dispose.from(action).create({
            all: true,
          }),
        ),
      ),
)
